import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import GeneralModal from "../../modals/GeneralModal";
import ActionItem from "./ActionItem";
import moment from "moment";
import ActionQueueHistoryModal from "./ActionQueueHistoryModal";

const ActionRow = ({
  aq,
  providers,
  showMonth = false,
  patientOnly = false,
  reloadData,
  reloadCount = () => {},
  reloadPrograms = (value: boolean) => {},
}) => {
  const [showHistoryModal, setShowHistoryModal] = React.useState(false);
  const [showHistoryFor, setShowHistoryFor] = React.useState<number>();

  const getDateColor = (dateStr) => {
    const today = moment().startOf("day");
    const date = moment(dateStr).startOf("day");
    if (date.isBefore(today)) {
      return { background: "red", text: "white" };
    } else if (date.isSame(today)) {
      return { background: "#FF890A", text: "white" };
    } else {
      return { background: "#EFE9E8", text: "black" };
    }
  };

  const [showResourceModal, setShowResourceModal] = useState(false);
  const [resources, setResources] = useState<any>([]);

  return (
    <>
      <GeneralModal
        open={showResourceModal}
        title={`Action/Step Resource(s)`}
        successCallback={undefined}
        closeCallback={() => {
          setShowResourceModal(false);
          setResources([]);
        }}
        showContinueIcon={false}
        showCancelButton={false}
      >
        <Grid container>
          <Grid item xs={12} mt={3}>
            {!!resources && resources?.length > 0 ? (
              resources.map((resource) => (
                <li key={resource.id}>
                  <a href={resource.link} target="_blank" rel="noreferrer">
                    {resource.name}
                  </a>
                </li>
              ))
            ) : (
              <div>No associated resources</div>
            )}
          </Grid>
        </Grid>
      </GeneralModal>
      {showHistoryModal && setShowHistoryFor && (
        <ActionQueueHistoryModal
          open={showHistoryModal}
          onCloseModal={() => {
            setShowHistoryFor(undefined);
            setShowHistoryModal(false);
          }}
          actionQueueId={showHistoryFor}
        />
      )}

      <Box
        sx={{
          display: "flex",
          gridTemplateColumns: "1fr 11fr",
          alignItems: "stretch",
          padding: "10px 0",
          width: "100%",
        }}
      >

        <Box
          sx={{
            display: "flex",
          padding: "10px 0",
          width: "100%",
        }}
      >
        <Box
          className="action-table-row"
          display={"flex"}
          height={"auto"}
          alignItems={"flex-start"}
          sx={{ flexBasis: "120px", textAlign: "center", pl: "0 !important" }}
        >
          {aq.due_date && (
            <Grid
              container
              direction="column"
              alignItems="center"
              height={"100%"}
            >

              <Grid
                item
                sx={{
                  borderRight: `1px solid ${
                    getDateColor(aq?.due_date).background
                  }`,
                  width: "calc(100% - 10px)",
                  display: "flex",
                  justifyContent: "center",
                }}
                height={showMonth ? "calc(100% - 50px)" : "100%"}
              >
                <Box
                  sx={{
                    backgroundColor: `${getDateColor(aq?.due_date).background}`,
                    color: `${getDateColor(aq?.due_date).text}`,
                    borderRadius: "4px",
                    padding: "10px 12px",
                    paddingBottom: "17px",
                    textAlign: "center",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                    minWidth: "50px",
                    justifyContent: "center",
                    height: "50px",
                  }}
                >
                  <Typography
                    // variant="caption"
                    sx={{
                      fontSize: "0.55rem",
                    }}
                  >
                    {moment(aq.due_date).format("MMMM").toUpperCase()}
                  </Typography>
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    {moment(aq.due_date).format("D").toUpperCase()}
                  </Typography>
                  <Typography
                    // variant="caption"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "0.55rem",
                    }}
                  >
                    {moment(aq.due_date).format("dddd").toUpperCase()}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          )}
        </Box>
        <Box width={"100%"}>
          {aq.action_data?.map((actionQueue, index) => (
            <div key={actionQueue.action_queue_id}>
              <ActionItem
                aq={actionQueue}
                providers={providers}
                patientOnly={patientOnly}
                reloadCount={reloadCount}
                reloadData={reloadData}
                reloadPrograms={reloadPrograms}
              />
            </div>
          ))}
        </Box>
        </Box>
      </Box>
    </>
  );
};

export default ActionRow;
